module.exports = __webpack_public_path__ + "static/header-86f258200389a11ab46c3487fba75028.png";